<ng-container *ngIf="swiperProducts.products.length">
  <h2 class="title">
    {{ getProductCarouselTitle() }}
  </h2>
  <ng-container *ngIf="swiperProducts.listStyle === 'carousel'; else plainList">
    <div class="product-list" [class]="productCarouselCss()">
      <swiper [config]="swiperProducts.swiperConfig">
        <ng-template *ngFor="let sku of swiperProducts.products" swiperSlide>
          <div [ngClass]="swiperProducts.contentlet.listItemCssClass" class="dotcms-swiper">
            <ng-container *ngIf="swiperProducts.contentlet">
              <custom-dot-cms-product-item
                ishProductContext
                [sku]="sku"
                [configuration]="swiperProducts.displayProperties"
                [displayType]="swiperProducts.listItemStyle"
                [layout]="swiperProducts.contentlet.layout"
              ></custom-dot-cms-product-item>
            </ng-container>
          </div>
        </ng-template>
      </swiper>
    </div>
  </ng-container>

  <ng-template #plainList>
    <div class="product-list row">
      <div
        *ngFor="let sku of swiperProducts.products"
        class="product-list-item"
        [ngClass]="swiperProducts.contentlet.listItemCssClass"
      >
        <custom-dot-cms-product-item
          ishProductContext
          [sku]="sku"
          [configuration]="swiperProducts.displayProperties"
          [displayType]="swiperProducts.listItemStyle"
        ></custom-dot-cms-product-item>
      </div>
    </div>
  </ng-template>
</ng-container>
